import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import { COLUMN_WIDTH_100 } from '@modules/page-builder/config/column-constants';
import type { ImageColumnProps } from '@modules/page-builder/types';
import DetailSingleImage from '../detail-single-image-shell/DetailSingleImageShell';
import TagBar from '../../common/tag-bar/TagBar';
import {
    DetailPageTagBarContainer,
    SingleImageContainer,
} from '../../common/pagebuilder.style';
import type { TagType } from '~/modules/product-tagging/type';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import ImageWithPaintPicker from '../../common/image-with-paint-picker/ImageWithPaintPicker';
import { ImageModuleExtraSpacing } from '@modules/page-builder/component/detail/detail-modules/DetailModules.style';

interface SingleImageModuleProps {
    column: ImageColumnProps;
    columnsTags: TagType[];
}

const SingleImageModule = ({ column, columnsTags }: SingleImageModuleProps) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();
    if (!column.imageUrl) {
        return null;
    }

    return (
        <>
            <div className={css(SingleImageContainer, ImageModuleExtraSpacing)}>
                <DetailSingleImage
                    caption={column.caption}
                    libraryImage={column?.libraryImage}
                    tags={column.tags}
                    uniqueApprovedTags={column.uniqueApprovedTags}
                    imageURL={column.imageUrl}
                    dimension={column.dimension}
                >
                    <ImageWithPaintPicker
                        src={column.imageUrl}
                        width={column.dimension.width}
                        height={column.dimension.height}
                        layout={'fill'}
                        objectFit={'cover'}
                        sizes={getImagesSizes(COLUMN_WIDTH_100)}
                        alt={
                            column.caption || column?.libraryImage?.Title || ''
                        }
                    />
                </DetailSingleImage>
            </div>
            {!mobile && columnsTags.length > 0 && (
                <TagBar
                    className={css(DetailPageTagBarContainer)}
                    tags={columnsTags}
                    imageID={column?.libraryImage?.ID}
                />
            )}
        </>
    );
};

export default SingleImageModule;
